import styled from "styled-components";

export const SkipSeparator = styled.div`
  margin-top: 1.25rem;
  padding-top: 0.75rem;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
`;
